let scrollPosition = 0;

export const disableScrollEvents = () => {
  scrollPosition = window.scrollY;

  const scrollBarWidth =
    window.innerWidth - document.documentElement.clientWidth;

  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";

  if (scrollBarWidth > 0) {
    document.body.style.paddingRight = `${scrollBarWidth}px`;
  }
};

export const enableScrollEvents = () => {
  const top = document.body.style.top;

  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  document.body.style.paddingRight = "";

  if (top) {
    const y = parseInt(top.replace("px", ""), 10) * -1;
    window.scrollTo(0, y);
  }
};
